import { isEmpty } from 'lodash-es';

export const convertObjectToQueryString = (object?: Object): string => {
  if (!object || isEmpty(object)) {
    return '';
  }

  const queryParams: string[] = [];

  Object.entries(object).map(([key, value]) => {
    queryParams.push(`${key}=${value}`);
  });

  return queryParams.join('&');
};
